var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCopyBlack2 = function SvgCopyBlack2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.515 1.514c0-.468.38-.848.849-.848h11.878c.469 0 .849.38.849.848V15.94H.515V1.514Zm1.697 12.728h10.182V2.363H2.212v11.879Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.212 2.363h10.182v11.879H2.212V2.363Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.91 4.908c0-.468.379-.848.848-.848h11.878c.469 0 .849.38.849.848v14.425H3.909V4.908Zm1.696 12.728h10.182V5.756H5.606v11.88Z",
    fill: "#424242"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.606 5.757h10.182v11.879H5.606V5.756Z",
    fill: "#fff"
  })));
};

export default SvgCopyBlack2;